import { render, staticRenderFns } from "./routing.vue?vue&type=template&id=f94f3cde&scoped=true"
import script from "./routing.vue?vue&type=script&lang=js"
export * from "./routing.vue?vue&type=script&lang=js"
import style0 from "./routing.vue?vue&type=style&index=0&id=f94f3cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94f3cde",
  null
  
)

export default component.exports